import { createReducer, on } from '@ngrx/store';
import { changeLanguage } from './language.actions';


export const initialState = "en";

// example ==> https://ngrx.io/guide/store

export const languageReducer = createReducer(
  initialState,
  on(changeLanguage, (state, payload) => state = payload.parameters),
);